module.exports = __webpack_public_path__ + "static/img/2areaB_9.de880d7.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character2/2areaB_9.png
// module id = 1150
// module chunks = 1